import React, { SVGAttributes } from 'react';
import { classNames } from '@fullstory/util/fmt';
import colors from './colors.module.scss';

interface CircleProps extends SVGAttributes<SVGCircleElement> {
  fill?: keyof typeof colors;
}

export const Circle: React.FC<CircleProps> = ({ fill, className, ...restOfProps }) => {
  let fillClass = '';
  if (fill) {
    fillClass = colors[fill];
  }

  return (
    <circle
      data-component="Circle"
      data-testid="circle"
      {...restOfProps}
      className={classNames(className, fillClass)}
    />
  );
};
